import React, { useRef } from 'react';
import styled from '@emotion/styled';
import { useModalStore } from '@/store/modalStore';
import CompleteIcon from '@/assets/img/icon/complete.svg';

const Modal = () => {
	const { message, isOpen, closeModal, type, clickModal, buttonText } = useModalStore();
	const modalRef = useRef<HTMLDivElement>(null);

	if (!isOpen) return null;

	const handleContainerClick = (e: React.MouseEvent) => {
		if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
			closeModal();
		}
	};

	return (
		<Container onClick={handleContainerClick}>
			{type === 'login' && (
				<LoginContainer ref={modalRef}>
					<ImgBox>
						<img src={CompleteIcon} alt="가입완료" />
					</ImgBox>
					<LoginMessage>{message}</LoginMessage>
					<PaymentConfirmButton onClick={clickModal}>{buttonText}</PaymentConfirmButton>
				</LoginContainer>
			)}

			{type === 'twoBtn' && (
				<LoginContainer ref={modalRef}>
					<ImgBox>
						<img src={CompleteIcon} alt="가입완료" />
					</ImgBox>
					<LoginMessage>{message}</LoginMessage>
					<PaymentButtonList>
						<PaymentCloseButton onClick={closeModal}>취소</PaymentCloseButton>
						<PaymentConfirmButton onClick={clickModal}>{buttonText}</PaymentConfirmButton>
					</PaymentButtonList>
				</LoginContainer>
			)}

			{type === 'register' && (
				<ToastContainer ref={modalRef}>
					<Title>타이키파트너스</Title>
					<Message>{message}</Message>
					<ButtonListBox>
						<CloseButton onClick={closeModal}>취소</CloseButton>
						<RegisterButton onClick={clickModal}>등록</RegisterButton>
					</ButtonListBox>
				</ToastContainer>
			)}

			{type !== 'login' && type !== 'register' && type !== 'twoBtn' && (
				<ToastContainer ref={modalRef}>
					<Title>타이키파트너스</Title>
					<Message>{message}</Message>
					<ConfirmButton onClick={closeModal}>확인</ConfirmButton>
				</ToastContainer>
			)}
		</Container>
	);
};

export default Modal;

// ✅ 스타일 정의
const Container = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	z-index: 25;
`;
const ImgBox = styled.div`
	display: flex;
	width: 100%;
	width: 11.8rem;
	height: 11.8rem;
	margin-top: 2rem;
	img {
		width: 100%;
		height: 100%;
	}
`;
const LoginContainer = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;
	padding: 2rem;
	max-width: 48rem;
	width: 100%;
	overflow-y: auto;
	background-color: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	color: #212529;
`;

const ToastContainer = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	gap: 1.7rem;
	padding: 1.6rem;
	max-width: 41.7rem;
	width: 100%;
	overflow-y: auto;
	background-color: #292a2d;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	border-radius: 0.4rem;
	color: #fff;
`;

const Title = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	color: #e8eaed;
	letter-spacing: -0.08px;
	line-height: normal;
`;

const Message = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	color: #e8eaed;
	line-height: normal;
	white-space: pre-line;
	letter-spacing: 0.32px;
`;
const LoginMessage = styled(Message)`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	color: #212529;
	letter-spacing: -0.6px;
	line-height: 130%;
	text-align: center;
`;

const ConfirmButton = styled.button`
	width: 7.3rem;
	height: 3.3rem;
	border-radius: 0.4rem;
	background: rgba(255, 255, 255, 0.1);
	border: none;
	color: #ffff;
	font-size: ${(props) => props.theme.fontSize.sizeXs};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	letter-spacing: 0.26px;
	margin-left: auto;
	cursor: pointer;

	&:hover {
		background-color: #505153;
	}
`;
const RegisterButton = styled(ConfirmButton)`
	margin-left: unset;
`;

const CloseButton = styled(ConfirmButton)`
	background-color: transparent;
	color: #fff;
	border: 1px solid rgba(255, 255, 255, 0.2);
	margin-left: unset;
`;

const PaymentConfirmButton = styled.button`
	background-color: ${(props) => props.theme.colors.primary400};
	color: #ffffff;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	letter-spacing: -0.6px;
	line-height: 100%;
	width: 100%;
	padding: 0rem 1.2rem;
	height: 4.4rem;
	border: none;
	cursor: pointer;
`;
const PaymentCloseButton = styled(PaymentConfirmButton)`
	background-color: transparent;
	color: #01337d;
	border: 1px solid #01337d;
`;
const ButtonListBox = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: flex-end;
	gap: 1rem;
`;

const PaymentButtonList = styled.div`
	display: flex;
	width: 100%;
	gap: 1.2rem;
`;
